import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { GlobalLoadingIndicator } from "./components/global-loading-indicator";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const createRouter = () => {
  return createTanstackRouter({
    routeTree,
    scrollRestoration: true,
    // 预加载结果缓存 5 分钟，避免鼠标悬停/intent 预加载反复打接口
    defaultPreloadStaleTime: 5 * 60_000,
    // Global pending component - shown during route transitions
    defaultPendingComponent: GlobalLoadingIndicator,
    // Only show loading indicator if navigation takes longer than 300ms
    // This prevents flash of loading state for fast navigations
    defaultPendingMs: 300,
  });
};

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
